import { EditableType, EditorType } from '../../constants';
import * as helpers from '../helpers';
import { MediaElement, VideoSettings, VideoParam, youtubeJsApiAttribute } from './typing';
import constants from '../indesignEditor/constants';
import { EditableItem } from '../htmlEditor/constants';

export const isIframe = (type: EditableType, isExternalLinkActive: boolean): boolean => (
	type === EditableType.video && isExternalLinkActive
);

const getImageElement = (htmlDocument: HTMLDocument, src: string): HTMLImageElement => {
	const image = htmlDocument.createElement('img');
	image.src = src;

	return image;
};

const getVideoElement = (editorType: EditorType, htmlDocument: HTMLDocument, src: string, videoSettings: VideoSettings): HTMLVideoElement => {
	const video = htmlDocument.createElement('video');

	if (editorType === EditorType.HTML) {
		video.setAttribute(EditableItem.Video, '');
	} else {
		video.className = constants.videoClassName;
	}

	video.setAttribute('width', '100%');
	video.setAttribute('height', '100%');

	Object.keys(videoSettings).forEach((key) => {
		if (videoSettings[key]) {
			video.setAttribute(key, '');
		}
	});

	const source = htmlDocument.createElement('source');
	source.src = src;
	source.type = 'video/mp4';

	video.appendChild(source);

	return video;
};

const getIframeElement = (editorType: EditorType, htmlDocument: HTMLDocument, src: string, videoSettings: VideoSettings): HTMLIFrameElement => {
	const iframe = htmlDocument.createElement('iframe');

	if (editorType === EditorType.HTML) {
		iframe.setAttribute(EditableItem.Video, '');
	} else {
		iframe.className = constants.videoClassName;
	}

	let modifiedSrc = src.split('?')[0]; // remove query params
	modifiedSrc = `${modifiedSrc}?${youtubeJsApiAttribute}`;

	Object.keys(videoSettings).forEach((key) => {
		const attributeName = key === VideoParam.muted ? 'mute' : key;
		modifiedSrc += `&${attributeName}=${getYoutubeAttributeValue(videoSettings[key])}`;
	});

	iframe.src = modifiedSrc;
	iframe.setAttribute('frameborder', '0');
	iframe.setAttribute('width', '100%');
	iframe.setAttribute('height', '100%');
	iframe.setAttribute('allowFullScreen', 'true');

	return iframe;
};

const getYoutubeAttributeValue = (attribute: string): number => attribute ? 1 : 0;

export const getElement = (
	editorType: EditorType,
	type: EditableType,
	isExternalLinkActive: boolean,
	htmlDocument: HTMLDocument,
	src: string,
	videoSettings?: VideoSettings,
): MediaElement => {
	switch (type) {
		case EditableType.video:
			return isExternalLinkActive
				? getIframeElement(editorType, htmlDocument, src, videoSettings as VideoSettings)
				: getVideoElement(editorType, htmlDocument, src, videoSettings as VideoSettings);
		case EditableType.image:
		default:
			return getImageElement(htmlDocument, src);
	}
};

export const getDriveLinkWithoutHash = (driveLink: string): string => driveLink.split('?')[0];

interface DataAttributes {
	[k: string]: string | number | boolean | undefined;
}

export const setDataAttributes = (element: HTMLElement, attributes: DataAttributes): void => {
	Object.entries(attributes).forEach(([key, value]) => {
		if (value) {
			element.setAttribute(key, value.toString());
		}
	});
};

export const setTooltipActions = (element: HTMLElement, tooltip: string, isTooltipActive: boolean): void => {
	if (isTooltipActive) {
		element.setAttribute('onmouseenter', helpers.getTooltipAction(helpers.TooltipAction.SHOW, tooltip));
		element.setAttribute('onmouseleave', helpers.getTooltipAction(helpers.TooltipAction.HIDE));
	} else {
		element.removeAttribute('onmouseenter');
		element.removeAttribute('onmouseleave');
	}
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/Editor/utils/editableMedia/saveData.ts